// extracted by mini-css-extract-plugin
export var banner = "_iv-0";
export var closeButton = "_iv-2";
export var greenCheckmark = "_iv-3";
export var hereLink = "_iv-4";
export var titleIcon = "_iv-1";